/* global wc_cp_composite_scripts */

( function( $ ) {

	$( '.composite_data' )

	.on( 'wc-composite-initializing', function( event, composite ) {

		// get_component_totals
		// component_selection_changed
		// component_selection_content_changed
		// component_totals_changed
		// composite_totals_changed
		composite.actions.add_action( 'composite_totals_changed', function () {

			var newPrice = composite.api.get_composite_totals().price;

			var urlLink	 = document.getElementById('update_finance_link');
			var urlInput = document.getElementById('update_finance_input');
			if (urlInput) {
				var urlStart = urlInput.dataset.urlStart;
				var urlEnd	 = String(urlInput.dataset.urlEnd);
				var urlNew 	 = urlStart + '&v8=' + newPrice + urlEnd;
			}
			
			if (urlLink) {
				urlLink.setAttribute('href', urlNew);
			}

		}, 100);
	} );

} )( jQuery );
